import { RunLog } from "../runLog";

export class IdiotRunLog extends RunLog { }
